// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"c787a931","230":"fa8388c5"}[chunkId] + ".chunk.css";
};